<script lang="ts">
import layout from '~/consumer/layouts/DefaultLayout.vue'
export default { layout }

</script>
<script setup lang="ts">import { ref as _ref, computed as _computed } from 'vue';

import CustomizerModal from '@consumer/modules/customizer/CustomizerModal.vue'
import type { CustomizerOptions, CustomizePurchasedGift, MultiplaceGift, GiftIdea } from '@consumer/types/serializers'
import { useUrlSearchParams, type UrlParams } from '@vueuse/core'
import { decodeGift } from '@consumer/composables/giftTemplate'
import type GiftTemplate from '@consumer/types/GiftTemplate'
import type { SpecOptions } from '@consumer/composables/spec'
import { useOrderStore } from '@consumer/services/order'

onMounted(useOrderStore().initialize)

type CustomizeGift = CustomizerOptions | CustomizePurchasedGift

withDefaults(defineProps<{
  customizerOptions?: CustomizeGift
  backUrl?: string
  createGiftIdea?: boolean
  giftIdea?: GiftIdea // Editing gift idea
}>(), {  })

const urlParams = useUrlSearchParams('history')

const initialGift = _ref<GiftTemplate>(giftFromParams(urlParams))

const specOptions = _computed<SpecOptions>(() => ({
  purchaseMethod: urlParams.purchase_method as string || 'customizer',
}))

function giftFromParams (params: UrlParams) {
  if (params.gift) { return decodeGift(params.gift.toString()) }

  return __props.customizerOptions || {}
}

const createMultiplace = (__props.customizerOptions as CustomizerOptions)?.createOrEditMultiplace || urlParams.mp === 'true'
const multiplaceGift = createMultiplace ? { amounts: [100, 150, 250] } as MultiplaceGift : null

const isCreatingGiftIdea = Boolean(__props.createGiftIdea || __props.giftIdea)

const giftSeries = (__props.customizerOptions as CustomizerOptions)?.giftSeries
if (giftSeries) {
  initialGift.value.giftlyMetadata = giftSeries.giftlyMetadata

  if (multiplaceGift) {
    if (giftSeries.amounts) multiplaceGift.amounts = giftSeries.amounts
    if (giftSeries.giftlyMetadata) multiplaceGift.giftlyMetadata = giftSeries.giftlyMetadata
    if (giftSeries.giftTags) multiplaceGift.giftTags = giftSeries.giftTags
  }
}

// Properties specific to editing purchased gifts (CustomizePurchasedGift)
const isMailableGift = Boolean((__props.customizerOptions as CustomizePurchasedGift)?.isMailable)
const giftId = (__props.customizerOptions as CustomizePurchasedGift)?.giftId

// Clean up gift_id from URL if user doesn't have permission to edit
onMounted(() => {
  if (urlParams.gift_id && !giftId) {
    delete urlParams.gift_id
  }
})

</script>

<template>
  <CustomizerModal
    :gift="initialGift"
    :specOptions
    :standalone="Boolean(customizerOptions)"
    :backUrl="backUrl"
    :createOrEditMultiplace="createMultiplace"
    :multiplaceGift="multiplaceGift"
    :giftSeries="giftSeries"
    :isMailableGift="isMailableGift"
    :giftId="giftId"
    :createGiftIdea="isCreatingGiftIdea"
    :giftIdea="giftIdea"
  />
</template>
